/*global Modernizr */
/*jslint browser:true */

(function() {
    'use strict';

    var scroll_top_trigger = document.getElementById('scroll-top');
    if(scroll_top_trigger) {
      var lastKnownScrollPosition,
          ticking = false;

      scroll_top_trigger.addEventListener('click', mowgli_scroll_top);
      scroll_top_trigger.addEventListener('touchstart', mowgli_scroll_top);

      document.addEventListener('scroll', (e) => {
        lastKnownScrollPosition = window.scrollY;

        if (!ticking) {
          window.requestAnimationFrame(function() {
            if(lastKnownScrollPosition > 80) {
              scroll_top_trigger.classList.add('show');
            } else {
              scroll_top_trigger.classList.remove('show');
            }

            ticking = false;
          });

          ticking = true;
        }
      }, { passive: true });
    }

    function mowgli_scroll_top(e) {
      e.preventDefault();

      window.scrollTo({top: 0, behavior: 'smooth'});
    }
}());
